module.exports = __webpack_public_path__ + "img/ahak.ff398fa4.jpg";